import { useRoute } from '#imports';
import { parseInt10 } from '@core/utils/utility';

export function useCommonIdEventData() {
  const route = useRoute();
  const query = route.query;
  const data = {} as {
    problem_id?: number;
    training_id?: number;
    contest_id?: number;
    group_id?: number;
    warehouse_id?: number;
  };

  if (query.pid) {
    data.problem_id = parseInt10(query.pid);
  }
  if (query.tid) {
    data.training_id = parseInt10(query.tid);
  }
  if (query.cid) {
    data.contest_id = parseInt10(query.cid);
  }
  if (query.gid) {
    // gid最多14位
    const gid = query.gid.slice(0, 14);
    data.group_id = parseInt10(gid);
  }
  if (query.wid) {
    data.warehouse_id = parseInt10(query.wid);
  }

  return data;
}
